var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrizeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_211",
    x: 0,
    y: 0,
    width: 97,
    height: 97,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734",
    transform: "translate(-645.54 -711.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 645.54, 711.54)",
    filter: "url(#Ellipse_211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_211-2",
    "data-name": "Ellipse 211",
    transform: "translate(5 5)",
    fill: "#ffc629",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 41,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735",
    transform: "translate(673.826 728.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566",
    transform: "translate(7.205 20.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(1.201 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M55.808,86.1,45,91.628V52H66.616V91.628Z",
    transform: "translate(-45 -52)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558",
    transform: "translate(18.013 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M63.8,52V91.628L59,89.174V52Z",
    transform: "translate(-59 -52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(1.201 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M45,52V91.628l4.8-2.454V52Z",
    transform: "translate(-45 -52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560",
    transform: "translate(6.004 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M49,52V69.295l2.295-.554L55,71.214l3.71-2.472,2.294.554V52Z",
    transform: "translate(-49 -52)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(18.013 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M59,52V69.3l2.268.548,2.294-3.468.242-.022V52Z",
    transform: "translate(-59 -52)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562",
    transform: "translate(1.201 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M45,52V66.353l.242.022,2.294,3.468L49.8,69.3V52Z",
    transform: "translate(-45 -52)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(16.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M64,93.03a1.2,1.2,0,0,1-.546-.131l-4.8-2.455A1.2,1.2,0,0,1,58,89.375V52.2A1.2,1.2,0,0,1,59.2,51H64a1.2,1.2,0,0,1,1.2,1.2V91.829a1.2,1.2,0,0,1-1.2,1.2Zm-3.6-4.39,2.4,1.227V53.4H60.4Z",
    transform: "translate(-58 -51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564",
    transform: "translate(4.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M49.2,87.026a1.2,1.2,0,0,1-1.2-1.2V52.2a1.2,1.2,0,1,1,2.4,0V85.825A1.2,1.2,0,0,1,49.2,87.026Z",
    transform: "translate(-48 -51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M66.816,93.03a1.2,1.2,0,0,1-.546-.131L56.009,87.654,45.747,92.9A1.2,1.2,0,0,1,44,91.829V72.616a1.2,1.2,0,0,1,2.4,0V89.867l9.061-4.631a1.194,1.194,0,0,1,1.093,0l9.061,4.631V53.4H46.4V69.013a1.2,1.2,0,1,1-2.4,0V52.2A1.2,1.2,0,0,1,45.2,51H66.816a1.2,1.2,0,0,1,1.2,1.2V91.829a1.2,1.2,0,0,1-1.2,1.2Z",
    transform: "translate(-44 -51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(1.201 1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M72.554,56.1l2.472-3.09L72.554,49.92l1.1-3.8-3.467-1.912-.437-3.932-3.936-.439-1.908-3.467-3.8,1.1L57.013,35l-3.09,2.472-3.8-1.1-1.909,3.467-3.936.439-.437,3.932L40.371,46.12l1.1,3.8L39,53.013l2.472,3.09-1.1,3.8,3.466,1.908.439,3.936,3.932.437,1.912,3.468,3.8-1.1,3.091,2.473,3.092-2.472,3.8,1.1,1.912-3.468,3.932-.437.439-3.934,3.465-1.909Z",
    transform: "translate(-39 -35)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568",
    transform: "translate(24.884 2.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M71.065,52.784l-2.472-3.092,1.1-3.8-3.467-1.912-.437-3.932-3.936-.439-1.908-3.467-1.223.354,1.371,3.112,3.149.439.349,3.932,2.773,1.912-.88,3.8,1.977,3.092-1.977,3.09.88,3.8-2.772,1.909-.351,3.934-3.147.437-1.373,3.114,1.223.354,1.912-3.468,3.932-.437.439-3.934,3.465-1.909-1.1-3.8Z",
    transform: "translate(-58.722 -36.142)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(1.201 2.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M46.823,65.52l-.351-3.936L43.7,59.677l.881-3.8L42.6,52.784l1.978-3.092-.882-3.8,2.775-1.912.349-3.932,3.148-.439L51.343,36.5l-1.223-.354-1.909,3.467-3.936.439-.437,3.932L40.371,45.89l1.1,3.8L39,52.784l2.472,3.09-1.1,3.8,3.466,1.908.439,3.936,3.932.437,1.912,3.468,1.222-.354-1.373-3.114Z",
    transform: "translate(-39 -36.142)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M57.214,72.427a1.2,1.2,0,0,1-.751-.263l-2.6-2.085-3.2.929a1.207,1.207,0,0,1-1.387-.574l-1.61-2.923-3.313-.367a1.2,1.2,0,0,1-1.062-1.062l-.37-3.317-2.92-1.608a1.2,1.2,0,0,1-.574-1.386l.928-3.205-2.083-2.6a1.2,1.2,0,0,1,0-1.5l2.083-2.606-.035-.121a1.2,1.2,0,0,1,2.307-.669l.209.719a1.2,1.2,0,0,1-.216,1.084l-1.873,2.343,1.872,2.34a1.2,1.2,0,0,1,.216,1.084l-.833,2.88,2.624,1.445a1.2,1.2,0,0,1,.614.92l.333,2.981,2.978.331a1.2,1.2,0,0,1,.919.614l1.448,2.626,2.88-.836a1.2,1.2,0,0,1,1.084.216l2.342,1.875,2.343-1.873a1.2,1.2,0,0,1,1.084-.216l2.878.836,1.447-2.627a1.2,1.2,0,0,1,.92-.614l2.977-.331.333-2.979a1.2,1.2,0,0,1,.614-.92l2.625-1.446L71.6,56.637a1.207,1.207,0,0,1,.216-1.083l1.873-2.34-1.873-2.343a1.2,1.2,0,0,1-.216-1.083l.835-2.878L69.808,45.46a1.2,1.2,0,0,1-.614-.919l-.331-2.977-2.981-.333a1.2,1.2,0,0,1-.92-.614l-1.445-2.625-2.878.832a1.2,1.2,0,0,1-1.084-.215l-2.342-1.872-2.34,1.872a1.207,1.207,0,0,1-1.084.216l-2.88-.833-1.446,2.625a1.2,1.2,0,0,1-.919.614l-2.981.333-.331,2.977a1.2,1.2,0,0,1-.614.92l-3.467,1.912a1.2,1.2,0,0,1-1.16-2.1l2.923-1.612.367-3.313a1.2,1.2,0,0,1,1.06-1.06l3.317-.37,1.609-2.922a1.2,1.2,0,0,1,1.386-.574l3.205.928,2.6-2.083a1.2,1.2,0,0,1,1.5,0l2.6,2.082,3.2-.927a1.2,1.2,0,0,1,1.386.574l1.608,2.922,3.317.37a1.2,1.2,0,0,1,1.062,1.06l.367,3.313,2.922,1.612a1.2,1.2,0,0,1,.574,1.386l-.927,3.2,2.083,2.606a1.2,1.2,0,0,1,0,1.5l-2.083,2.6.927,3.205a1.2,1.2,0,0,1-.574,1.386l-2.92,1.609-.369,3.316a1.2,1.2,0,0,1-1.062,1.062l-3.313.367-1.612,2.923a1.2,1.2,0,0,1-1.386.574l-3.2-.928-2.606,2.083A1.2,1.2,0,0,1,57.214,72.427Z",
    transform: "translate(-38 -34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(7.205 7.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572",
    transform: "translate(0.913 0.354)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 10.818,
    cy: 10.818,
    r: 10.818,
    transform: "translate(0 0)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    transform: "translate(10.808 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M54.2,41a11.021,11.021,0,0,0-1.2.071,10.8,10.8,0,0,1,0,21.474A10.806,10.806,0,1,0,54.2,41Z",
    transform: "translate(-53 -41)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574",
    transform: "translate(1.201 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M47.4,51.808a10.8,10.8,0,0,1,9.607-10.737,11.022,11.022,0,0,0-1.2-.071,10.808,10.808,0,1,0,1.2,21.545A10.8,10.8,0,0,1,47.4,51.808Z",
    transform: "translate(-45 -41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M56.009,64.017A12.022,12.022,0,0,1,44,52.009a12.157,12.157,0,0,1,.2-2.208,1.2,1.2,0,1,1,2.362.437A9.608,9.608,0,1,0,56.009,42.4a9.517,9.517,0,0,0-5.816,1.96,1.2,1.2,0,1,1-1.455-1.909A11.9,11.9,0,0,1,56.009,40a12.009,12.009,0,1,1,0,24.017Z",
    transform: "translate(-44 -40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576",
    transform: "translate(1.27 4.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M46.258,47.382A1.2,1.2,0,0,1,45.2,45.615a11.889,11.889,0,0,1,.905-1.439A1.2,1.2,0,1,1,48.041,45.6a9.765,9.765,0,0,0-.724,1.15A1.2,1.2,0,0,1,46.258,47.382Z",
    transform: "translate(-45.058 -43.685)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeIcon);
export default __webpack_public_path__ + "static/media/prizeIcon.2c212233dddc56294c908c5850273ac8.svg";
export { ForwardRef as ReactComponent };